"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPreviewModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var molecules_1 = require("../../molecules");
var DocumentWebViewerProvider_1 = require("../../providers/DocumentWebViewerProvider");
/**
 * ContentPreviewModal wrapper for DocumentWebViewer
 *
 * @see DocumentWebViewerProvider
 * @see ContentPreviewModal
 * @see DocumentWebViewer
 */
exports.DocumentPreviewModal = react_1.default.memo(function (_a) {
    var _b = _a.contentPreviewModalProps, contentPreviewModalProps = _b === void 0 ? {} : _b, documentWebViewerProps = _a.documentWebViewerProps, _c = _a.onReady, onReady = _c === void 0 ? function () { } : _c;
    // NOTE: needs to be wrapped in a provider
    var setInstance = react_1.default.useContext(DocumentWebViewerProvider_1.DocumentWebViewerContext).setInstance;
    return ((0, jsx_runtime_1.jsx)(core_1.Portal, { children: (0, jsx_runtime_1.jsx)(molecules_1.ContentPreviewModal
        // defaulting this width here for this specific usage instead of in the content modal directly
        , __assign({ 
            // defaulting this width here for this specific usage instead of in the content modal directly
            drawerWidth: "420px" }, contentPreviewModalProps, { children: (0, jsx_runtime_1.jsx)(molecules_1.DocumentWebViewerV2, __assign({}, documentWebViewerProps, { 
                // viewer load must set instance for the context
                onViewerLoad: function (instance) {
                    setInstance(instance);
                    // on ready call is essentially the same as onViewerLoad but gives us options if the instance fails or we want to make it async
                    onReady(instance);
                } })) })) }));
});
